import { camelCase } from "lodash";

// INFO - M.S - 20/05/2021 - flatten the responseObject
// example :
//
// {             {
//   a:2,         a:2,
//   b: {   ==>   c:3
//     c:3       }
//   }
// }
const flattenObject = (obj) => {
  const flattened = {};
  Object.keys(obj).forEach((key) => {
    if (!Array.isArray(obj[key]) && obj[key] instanceof Object) {
      Object.assign(flattened, flattenObject(obj[key]));
    } else {
      flattened[key] = obj[key];
    }
  });
  return flattened;
};

export const snakeToCamel = (data, flatten) => {
  if (!data) {
    return;
  }
  if (flatten === "flatten") {
    data = flattenObject(data);
  }

  Object.keys(data).forEach((key) => {
    if (key.includes("_")) {
      let newKey = key.replace(/([_][a-z])/g, (match) =>
        match.toUpperCase().replace("_", "")
      );
      Object.assign(data, { [newKey]: data[key] });
      delete data[key];
    }
  });
  return data;
};
function isValidUUIDv4(uuid) {
  const uuidV4Regex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidV4Regex.test(uuid);
}
export const camelizeKeys = (obj, deep = true) => {
  if (Array.isArray(obj)) {
    return obj.map((v) => camelizeKeys(v, deep));
  } else if (obj != null && obj.constructor === Object) {
    return Object.keys(obj).reduce((result, key) => {
      if (deep)
        return {
          ...result,
          [isValidUUIDv4(key) ? key : camelCase(key)]: camelizeKeys(obj[key]),
        };
      else
        return {
          ...result,
          [isValidUUIDv4(key) ? key : camelCase(key)]: obj[key],
        };
    }, {});
  }
  return obj;
};
